import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../common/base/base.component';
import { StateMasterService } from 'src/app/_services/state-master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageManagerService } from '../_services/languagemanager.service';
import { CountStates } from '../_models/count-states.model';
import { StorageService } from 'src/app/_services/storage.service';
import { ClaimOperationCPService } from '../_services/claim-operation-cp.service';
import { CountExpirate } from '../_models/count-expirate.model';
import { ClaimOperationCP } from '../_models/claim-operation-cp.model';
import { DatePipe } from '@angular/common';
import { StateMaster } from '../_models/state-master.model';
import { CurrencyCode } from '../_enums/currency-code';
import { state } from '@angular/animations';
import { DecimalPipe } from '@angular/common'; 
import { catchError, tap, throwError } from 'rxjs';

@Component({
  selector: 'DCO-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  standalone: false,
})
export class HomeComponent{}
/*
export class HomeComponent extends BaseComponent implements OnInit {
  //Estados disputas
  stateTypes = [
    '',
    'Final_desfavorable',
    'Final_favorable',
    'Gestionados',
    'Pendientes',
  ];
  claimOperationStates: CountStates[] = [];
  currentFormats: any;
  claimOperations: ClaimOperationCP[] = [];
  claimOperationsExpiredToday: ClaimOperationCP[] = [];
  claimOperationsAll: ClaimOperationCP[] = [];
  sortedclaimOperationsGrouped: [string, ClaimOperationCP[]][] = [];
  lstStatesMasters: StateMaster[] = [];
  statesIds: any[] = [];
  currentLanguage: string;
  page: number = 1;
  today: string;
  weekBefore: string;
  dateNow = new Date();
  tabName = 'Pendientes';
  totalValue: number = 0;
  totalPending: string;
  totalCreatedToday: number = 0;
  progressBar1: number = 0;
  progressBar2: number = 0;
  progressBar3: number = 0;
  progressBar4: number = 0;
  progressBar5: number = 0;
  tittleProgressBar1: string = '';
  tittleProgressBar2: string = '';
  tittleProgressBar3: string = '';
  tittleProgressBar4: string = '';
  loadComplete: boolean = false;

  parameters: any = {
    search: [],
    top: 0,
    order:   {by: 'ClaimOperationID',
  ordering: 'DESC' },
    boolOperator: "AND"
  };
  //Conteo para tabs proximas vencimiento/vencen hoy
  countClaimsOperations: CountExpirate;

  parametersCount: any = {
    search: '',
  };

  constructor(
    private ClaimOperationCP: ClaimOperationCPService,
    private StateMasterService: StateMasterService,
    public override router: Router,
    public override langService: LanguageManagerService,
    private StorageService: StorageService,
    private route: ActivatedRoute,
    private datePipe: DatePipe
  ) {
    super(router, langService, route);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.currentFormats =
      this.langService.dateAndCurrencyChangeFormat$.subscribe((formats) => {
        this.currentFormats = formats; // Guardamos los formatos actualizados para utilizarlos
      });
    this.currentLanguage = this.langService.GetCurrentLanguage();
    this.langService.updateFormats(this.currentLanguage); // Cargar los formatos iniciales
    // Conteo para mostrar en los tabs pendientes/gestionadas/resueltas a favor/resueltas desfavorables
    this.StateMasterService.GetCountStates().subscribe(
      (res) => {
        // obtenemos los estados que han llegado para dejar a 0 el resto.
        let stateTypesReceived = {};
        res.map(countState=>{
          stateTypesReceived[countState.stateGroup]=countState.countStates;
        });
        // guardamos los estados recibidos
        this.claimOperationStates = res;
        // metemos los estados que faltan
        this.stateTypes.map((stateType) => {
          if(!stateTypesReceived[stateType]){
            let countState = new CountStates();
            countState.countStates = '0';
            countState.stateGroup = stateType;
            if (this.claimOperationStates) {
              this.claimOperationStates.push(countState);
            }
          }
        });
        var pending: number = 0;
        var managed: number = 0;
        if (this.claimOperationStates != undefined) {
          this.claimOperationStates.forEach((states) => {
            if (states.stateGroup == 'Pendientes') {
              pending = Number(states.countStates);
            }
            if (states.stateGroup == 'Gestionados') {
              managed = Number(states.countStates);
            }
          });
          if(pending==0 && managed ==0){
            this.totalPending = '0%'
          }else{
            let procentaje = (pending / (pending + managed)) * 100;
            this.totalPending = procentaje.toFixed(2) + '%';
          }
        }

        // console.log("claimOperationStates", this.claimOperationStates);
      },
      (error) => {
        if (error.status == 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      }
    );
    // Conteo para mostrar en los tabs todos/proximas a vencimiento/ vencen hoy
    // this.StateMasterService.GetCountStates()
    //   .pipe(
    //     tap((res) => {
    //       this.countClaimsOperations = res;
    //     }),
    //     catchError((error) => {
    //       if (error.status === 401) {
    //         this.StorageService.clean();
    //         this.router.navigate(['/login']);
    //       }
    //       return throwError(() => error);
    //     }),
    //   )
    //   .subscribe();

    this.ClaimOperationCP.ClaimOperations_GetCount(
      this.parametersCount
    ).subscribe(
      (res) => {
        this.countClaimsOperations = res;
      },
      (error) => {
        if (error.status == 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      }
    );
    this.GetClaimList();
    this.GetClaimOperatiionsAll();
    this.SearchClaimsToday();
  }
  SearchClaimsToday() {
    this.page = 1;
    this.today = this.datePipe.transform(this.dateNow, 'yyyy-MM-dd');

    const filterClaimOp = {
        identifier: "ExpirationDate",
        value: this.today,
        type: 'date',
        operator: "="
    };

    if (!Array.isArray(this.parameters.search)) {
        this.parameters.search = [];
    }


    this.parameters.search.push(filterClaimOp);

    //this.parameters.search = `CO.ExpirationDate = '${this.today}'`;

    this.ClaimOperationCP.ClaimOperations_Get(this.parameters).subscribe(
      (res) => {
        this.claimOperationsExpiredToday = res.data;
      },
      (error) => {
        if (error.status == 401) {
          this.StorageService.clean();
          this.router.navigate(['/login']);
        }
      }
    );
    this.parameters.search = [];
  }
  AddDays(date: Date, days: number): Date {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    // console.log(result);
    return result;
  }

  GetClaimList(): void {
    this.StateMasterService.GetState().subscribe((states) => {
      this.lstStatesMasters = states;
      this.FilterByState();
      this.ClaimOperationCP.ClaimOperations_Get(this.parameters).subscribe(
        (res) => {
          this.claimOperations = res.data;
        },
        (error) => {
          if (error.status == 401) {
            this.StorageService.clean();
            this.router.navigate(['/login']);
          }
        }
      );
      this.parameters.search = [];
    });
  }

  summaries = {};
  summariesFormated = {};
  hasSummaries = false;

  subReasonsCount: Record<string, number> = {};
  subReasonsCountSorted: Array<{ subReasonname: string; count: number }> = [];

  GetClaimOperatiionsAll(): void {
    this.ClaimOperationCP.ClaimOperations_Get(this.parameters).subscribe(
      (res) => {
        this.claimOperationsAll = res.data;
        this.claimOperationsAll.map((operation) => {
          this.summaries[operation.currency] = 0;
          if (!this.subReasonsCount[operation.subReasonName]) {
            this.subReasonsCount[operation.subReasonName] = 1;
          } else {
            this.subReasonsCount[operation.subReasonName] =
              this.subReasonsCount[operation.subReasonName] + 1;
          }
        });
        this.today = this.datePipe.transform(this.dateNow, 'yyyy-MM-dd');
        if (this.claimOperationsAll.length == 0) {
          this.loadComplete = true;
        }
        if (this.claimOperationsAll.length > 0) {
          // this.claimOperationsAll.forEach((element) => {
          //   this.totalValue += element.amount;

          //   if (element.operationDate == this.today) {
          //     this.totalCreatedToday++;
          //   }
          // });
          this.claimOperationsAll.forEach((element) => {
            if (element.operationDate == this.today) {
              this.totalCreatedToday++;
            }
            this.summaries[element.currency] =
              this.summaries[element.currency] + element.amount;
            this.totalValue += element.amount;
          });
        } else {
          this.totalValue = 0;
        }
        Object.keys(this.summaries).map((key) => {
          this.hasSummaries = true;
          if (this.summaries[key] > 1000000) {
            this.summariesFormated[key] =
              this.roundTo(this.summaries[key] / 1000000, 2) + 'M';
          } else if (this.summaries[key] > 1000) {
            this.summariesFormated[key] =
              this.roundTo(this.summaries[key] / 1000, 2) + 'K';
          } else {
            this.summariesFormated[key] = this.roundTo(this.summaries[key], 2);
          }
        });

        Object.entries(this.subReasonsCount).forEach(([key, value]) => {
          let keyFormated = key == null || key == '' ? 'N/A' : key;
          //if(keyFormated=='N/A') to check visibility
          this.subReasonsCountSorted.push({
            subReasonname: keyFormated,
            count: value,
          });
        });
        this.subReasonsCountSorted = this.subReasonsCountSorted.sort((a, b) => {
          return b.count - a.count;
        });
        let otherSubreasons = this.claimOperationsAll.length;
        let position = 0;
        if (this.subReasonsCountSorted.length > 0) {
          this.tittleProgressBar1 =
            this.subReasonsCountSorted[position].subReasonname;
          this.progressBar1 = Number(
            (
              (this.subReasonsCountSorted[position].count /
                this.claimOperationsAll.length) *
              100
            ).toFixed(2)
          );
          otherSubreasons =
            otherSubreasons - this.subReasonsCountSorted[position].count;
            position = position + 1;
        }

        if (this.subReasonsCountSorted.length > 1) {
          this.tittleProgressBar2 =
            this.subReasonsCountSorted[position].subReasonname;
          this.progressBar2 = Number(
            (
              (this.subReasonsCountSorted[position].count /
                this.claimOperationsAll.length) *
              100
            ).toFixed(2)
          );
          otherSubreasons =
            otherSubreasons - this.subReasonsCountSorted[position].count;
            position = position + 1;
        }
        if (this.subReasonsCountSorted.length > 2) {
          this.tittleProgressBar3 =
            this.subReasonsCountSorted[position].subReasonname;
          this.progressBar3 = Number(
            (
              (this.subReasonsCountSorted[position].count /
                this.claimOperationsAll.length) *
              100
            ).toFixed(2)
          );
          otherSubreasons =
            otherSubreasons - this.subReasonsCountSorted[position].count;
            position = position + 1;
        }
        if (this.subReasonsCountSorted.length > 3) {
          this.tittleProgressBar4 =
            this.subReasonsCountSorted[position].subReasonname;
          this.progressBar4 = Number(
            (
              (this.subReasonsCountSorted[position].count /
                this.claimOperationsAll.length) *
              100
            ).toFixed(2)
          );
          otherSubreasons =
            otherSubreasons - this.subReasonsCountSorted[position].count;
            position = position + 1;
        }
        this.progressBar5 = Number(
          (
            (otherSubreasons /
              this.claimOperationsAll.length) *
            100
          ).toFixed(2)
        );
        

        // let claimOperationsGrouped = this.claimOperationsAll.reduce(
        //   (acc, item) => {
        //     if (!acc[item.subReasonName]) {
        //       acc[item.subReasonName] = [];
        //     }
        //     acc[item.subReasonName].push(item);
        //     return acc;
        //   },
        //   {} as Record<string, ClaimOperationCP[]>
        // );

        // this.sortedclaimOperationsGrouped = Object.entries(
        //   claimOperationsGrouped
        // ).sort((a, b) => {
        //   return b[1].length - a[1].length;
        // });

        // this.sortedclaimOperationsGrouped.forEach((group) => {
        //   if (group[0] === '' || group[0] === null) {
        //     group[0] = 'N/A';
        //   }
        // });

        // this.tittleProgressBar1 = '0';
        // this.tittleProgressBar2 = '0';
        // this.tittleProgressBar3 = '0';
        // this.tittleProgressBar4 = '0';

        // if (this.claimOperationsAll.length > 0) {
        //   this.tittleProgressBar1 = this.sortedclaimOperationsGrouped[0][0];
        //   this.tittleProgressBar2 = this.sortedclaimOperationsGrouped[1][0];
        //   this.tittleProgressBar3 = this.sortedclaimOperationsGrouped[2][0];
        //   this.tittleProgressBar4 = this.sortedclaimOperationsGrouped[3][0];
        // }

        // if (this.claimOperationsAll.length > 0) {
        //   this.progressBar1 = Number(
        //     (
        //       (this.sortedclaimOperationsGrouped[0][1].length /
        //         this.claimOperationsAll.length) *
        //       100
        //     ).toFixed(2)
        //   );
        //   this.progressBar2 = Number(
        //     (
        //       (this.sortedclaimOperationsGrouped[1][1].length /
        //         this.claimOperationsAll.length) *
        //       100
        //     ).toFixed(2)
        //   );
        //   this.progressBar3 = Number(
        //     (
        //       (this.sortedclaimOperationsGrouped[2][1].length /
        //         this.claimOperationsAll.length) *
        //       100
        //     ).toFixed(2)
        //   );
        //   this.progressBar4 = Number(
        //     (
        //       (this.sortedclaimOperationsGrouped[3][1].length /
        //         this.claimOperationsAll.length) *
        //       100
        //     ).toFixed(2)
        //   );
        //   this.progressBar5 = Number(
        //     (
        //       100 -
        //       (this.progressBar1 +
        //         this.progressBar2 +
        //         this.progressBar3 +
        //         this.progressBar4)
        //     ).toFixed(2)
        //   );
        // }
      }
    );
    this.parameters.search = [];
  }

  // Filtrar Claims por estado: Pendientes, gestionadas, resueltas a favor, resueltas desfavorables
  FilterByState(): void {
    this.statesIds = this.lstStatesMasters
      .filter((state) => state.state === this.tabName)
      .map((state) => state.stateMasterID);
    let states = this.statesIds.join(', ');

    const filterClaimOp = {
        identifier: "State",
        value: states,
        type: 'int',
        operator: "IN"
    };

    if (!Array.isArray(this.parameters.search)) {
        this.parameters.search = [];
      }


    this.parameters.search.push(filterClaimOp);

    //this.parameters.search = `CO.State IN (${states})`;
  }

  viewClaimOperatios(state: string): void {
    this.router.navigate(['/disputes/state', state]);
  }

  ProgressBar(
    progressBar1: number,
    progressBar2: number,
    progressBar3: number,
    progressBar4: number,
    progressBar5: number
  ): void {
    const widthprogressBar1 = document.getElementById(
      'progressBar1'
    ) as HTMLElement;
    widthprogressBar1.style.width = progressBar1 + '%';
    const widthprogressBar2 = document.getElementById(
      'progressBar2'
    ) as HTMLElement;
    widthprogressBar2.style.width = progressBar2 + '%';
    const widthprogressBar3 = document.getElementById(
      'progressBar3'
    ) as HTMLElement;
    widthprogressBar3.style.width = progressBar3 + '%';
    const widthprogressBar4 = document.getElementById(
      'progressBar4'
    ) as HTMLElement;
    widthprogressBar4.style.width = progressBar4 + '%';
    const widthprogressBar5 = document.getElementById(
      'progressBar5'
    ) as HTMLElement;
    widthprogressBar5.style.width = progressBar5 + '%';
  }

  roundTo(num, precision) {
    const factor = Math.pow(10, precision);
    return Math.round(num * factor) / factor;
  }

  getCurrencyCode(disputeCurrency: string): string {
    return this.langService.translate("@@CMP.ClaimDetails_Currency"+disputeCurrency);
    // switch (disputeCurrency) {
    //   case CurrencyCode.EUR:
    //     return 'EUR';
    //   case CurrencyCode.USD:
    //     return 'USD';
    //   case CurrencyCode.GBP:
    //     return 'GBP';
    //   default:
    //     return disputeCurrency;
    // }
  }
}
//*/